// extracted by mini-css-extract-plugin
module.exports = {"sourceBlock":"VisibilityDocumentContainer_sourceBlock__ajftb","name":"VisibilityDocumentContainer_name__2-oL0","visible":"VisibilityDocumentContainer_visible__1UsRy"};